// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tqhZ","fullView":"styles_fullView__3TcB5"};